import React from 'react';
import './pmp-demo-link.css';

export default function PmpDemoLink() {
  return (
    <a
      className="pmp-demo-link"
      href="http://pmidemo.benjaminsmartpower.com/HC/"
    >
      <strong>View Demo</strong>
    </a>
  );
}
